var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTableView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.676,
    height: 11.675,
    viewBox: "0 0 11.676 11.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "np_table_3550813_000000",
    d: "M29.924,20H21.751A1.752,1.752,0,0,0,20,21.751v8.173a1.752,1.752,0,0,0,1.751,1.751h8.173a1.752,1.752,0,0,0,1.751-1.751V21.751A1.752,1.752,0,0,0,29.924,20Zm-8.173,1.168h8.173a.584.584,0,0,1,.584.584V23.5h-9.34V21.751A.584.584,0,0,1,21.751,21.168Zm2.919,5.838V24.67h2.335v2.335Zm2.335,1.168v2.335H24.67V28.173Zm-3.5-1.168H21.168V24.67H23.5Zm4.67-2.335h2.335v2.335H28.173Zm-7.005,5.254V28.173H23.5v2.335H21.751A.584.584,0,0,1,21.168,29.924Zm8.757.584H28.173V28.173h2.335v1.751A.584.584,0,0,1,29.924,30.508Z",
    transform: "translate(-20 -20)",
    fill: "#7a7a7a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTableView);
export default __webpack_public_path__ + "static/media/icon_table-view.b1756113.svg";
export { ForwardRef as ReactComponent };